module.exports = __webpack_public_path__ + "static/media/S.5fd6e546.jpg";